import { Injectable } from '@angular/core';
// @ts-ignore
import format from 'date-fns/format';


@Injectable()
export class DateTimeService {
    userDateTimeFormat  = 'DD-MM-YYYY HH:mm:ss';
    eventDateTimeFormat = 'DD/MM HH:mm';
    eventDateNormal = 'DD.MM.YYYY';
    couponTimeFormat    = 'DD/MM HH:mm:ss';
    dateFormat          = 'DD/MM';
    hourFormat          = 'HH:mm';

    constructor() {
    }

    /**
     * Formats a date for display. Converts UTC from API to user's local time.
     * - Server strings like "2026-02-03 13:51:41" or "2026-02-03T13:51:41" (no Z, no offset)
     *   are treated as UTC, then displayed in the user's local timezone.
     */
    formatDate(date, dateFormat?) {
        if (!date || date === '0000-00-00 00:00:00') {
            return '';
        }

        let parsedDate: Date;

        if (date instanceof Date) {
            parsedDate = date;
        } else {
            const str = date.toString().trim();
            // No timezone in string → treat as UTC so display shows local time
            const hasNoTimezone = !/Z$/i.test(str) && !/[+-]\d{2}(:\d{2})?$/.test(str);
            const looksLikeDatetime = /^\d{4}-\d{2}-\d{2}[T\s]\d{2}:\d{2}(:\d{2})?/.test(str);
            const treatAsUtc = hasNoTimezone && looksLikeDatetime;

            let normalized = str.includes('T') ? str : str.replace(' ', 'T');
            if (treatAsUtc && !normalized.endsWith('Z')) {
                normalized = normalized + 'Z';
            }
            parsedDate = new Date(normalized);
        }

        if (isNaN(parsedDate.getTime())) {
            return '';
        }

        return format(parsedDate, dateFormat ? dateFormat : 'YYYY-MM-DD HH:mm:ss');
    }

    formatDateOnlyYearMonth(date, dateFormat?) {
        if (date && date !== '0000-00-00 00:00:00') {

            return format(date+ 'Z00:00', dateFormat ? dateFormat : 'YYYY-MM');
        }
        return '';
    }

    now(dateFormat?) {
        return format(new Date(), dateFormat ? dateFormat : 'YYYY-MM-DD');
    }
}
